// This file added by Bearer Web Developer
const getNextSomeDays = (days: number = 7, initDate?: string) => {
    // Get the date - initDate or today
    const date = initDate ? new Date(initDate) : new Date();
    // Create a new Date object for some days (days argument) later
    const futureDate = new Date(date); // Create a copy to avoid modifying 'date'
    futureDate.setDate(date.getDate() + days);
    // Extract year, month, and day
    const year = futureDate.getFullYear();
    const month = (futureDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = futureDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export default getNextSomeDays;